import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=6c8e2332&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"
import style0 from "./index_new.vue?vue&type=style&index=0&id=6c8e2332&prod&lang=scss&scoped=true"
import style1 from "./index_new.vue?vue&type=style&index=1&id=6c8e2332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e2332",
  null
  
)

export default component.exports